import { groupByExperiments, convertOneExperiment, } from 'brukerconverter';
import { convertToFloatArray } from '../utilities/convertToFloatArray';
import { formatSpectra } from '../utilities/formatSpectra';
import { getInfoFromMeta } from '../utilities/getInfoFromMeta';
const defaultConverterOptions = {
    keepRecordsRegExp: /.*/,
    keepFiles: true,
};
export async function readBruker(fileCollection, options = {}) {
    const output = { spectra: [], molecules: [] };
    const { converter = {}, selector = {}, keepSource = false, logger } = options;
    const parseData = [];
    const experiments = groupByExperiments(fileCollection, getSelector(selector));
    for (const experiment of experiments) {
        try {
            const result = await convertOneExperiment(experiment, {
                ...defaultConverterOptions,
                ...converter,
            });
            if (result) {
                parseData.push(result);
            }
        }
        catch (message) {
            if (logger)
                logger.error(message);
        }
    }
    for (const entry of parseData) {
        const metadata = { ...entry.info, ...entry.meta };
        const info = getInfoFromMeta(metadata, { logger });
        const dependentVariable = {};
        const { isFid } = info;
        if (isTwoD(entry)) {
            const minMax = entry.minMax;
            for (const key in minMax) {
                const minMaxContent = isFid
                    ? minMax[key]
                    : minMax[key];
                if (!minMaxContent)
                    continue;
                minMaxContent.z = convertToFloatArray(minMaxContent.z);
            }
            dependentVariable.components = entry.minMax;
        }
        else if (info.dimension === 1) {
            dependentVariable.components = entry.spectra;
        }
        const { source } = entry;
        const { expno: experimentNumber, name, files } = source;
        const result = {
            dependentVariables: [dependentVariable],
            meta: metadata,
            info: { ...info, experimentNumber, name: `${name}/${experimentNumber}` },
        };
        if (files && keepSource) {
            result.sourceSelector = {
                files: files.map((file) => file.relativePath),
            };
        }
        maybeAddIntegrals(result, entry);
        output.spectra.push(result);
    }
    return formatSpectra(output);
}
function getSelector(selector) {
    const { general = {}, bruker = {} } = selector;
    const { processingNumbers, experimentNumbers, ...restBruker } = bruker;
    return {
        ...general,
        ...restBruker,
        processingNumbers: getNumbers(processingNumbers),
        experimentNumbers: getNumbers(experimentNumbers),
    };
}
function getNumbers(data) {
    if (!data)
        return;
    return data
        .split(/[^\d]+/)
        .filter((item) => item)
        .map((item) => parseInt(item, 10));
}
function isTwoD(entry) {
    const { info } = entry;
    return info.twoD;
}
function maybeAddIntegrals(result, entry) {
    if (!('integrals' in entry))
        return;
    const { integrals = [] } = entry;
    result.integrals = {
        values: integrals.map((integral) => {
            const { from, to, integration } = integral;
            return {
                from,
                to,
                integral: integration,
                kind: 'signal',
            };
        }),
    };
}
//# sourceMappingURL=readBruker.js.map